import { type EnrollmentDetails } from 'core/types'
import { ServiceDateTypeSelection } from 'Pages/CaregiverPortal/InterestForm/Step3/ServiceDateTypeSelection'
import { ServiceSearchTypeSelection } from 'Pages/CaregiverPortal/InterestForm/Step3/ServiceSearchTypeSelection'
import { ServiceSelection } from 'Pages/CaregiverPortal/InterestForm/Step3/ServiceSelection'

export interface ServiceSelectionStepProps {
  handleStep: (backwards: boolean) => void
  caregiverForm: EnrollmentDetails
}

export function ServiceSelectionStep (props: ServiceSelectionStepProps): JSX.Element {
  const caregiverForm = props.caregiverForm

  if (caregiverForm.currentSubStep === 1) {
    return <ServiceSelection caregiverForm={caregiverForm} handleStep={props.handleStep} />
  } else if (caregiverForm.currentSubStep === 2) {
    return <ServiceDateTypeSelection caregiverForm={caregiverForm} />
  } else if (caregiverForm.currentSubStep === 3) {
    return <ServiceSearchTypeSelection caregiverForm={caregiverForm} handleStep={props.handleStep} />
  }

  return <></>
}
